import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Submit } from "../Button";
import axios from "axios";
import { useSelector } from "react-redux";
import { socket } from "../../services/socket/socket";
import swal from "sweetalert";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";

const screen = {
  width: "100%",
  height: "100%",
  position: "fixed",
  zIndex: "999",
  backgroundColor: "#11111136",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
};
const container = {
  // width:'30%',
  minHeight: "20vh",
  borderRadius: "10px",
  // maxHeight:'90vh',
  padding: "2rem 4rem",

  zIndex: "999",
  backgroundColor: "#f5f7fa",
};

const head = {
  display: "flex",
};

const header = {
  fontSize: "2rem",
  fontWeight: "600",
};
const para = {
  fontSize: "14px",
  fontWeight: "400",
  marginTop: "0px",
  color: "#696F79",
};

const input = {
  width: "20vw",
  height: "3rem",
  borderRadius: "6px",
  outline: "none",
  border: "1px solid #D0D0D0",
  padding: "10px",
  fontSize: "20px",
  margin: "15px",
  color: "var(--clr-font-dark)",
};
const footSelect = {
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  marginTop: "1.2rem",
};

const presetHeader = {
  fontSize: "14px",
  color: "var(--clr-font-mid)",
  margin: "0 15px 5px 0px",
  // width:'1px'
};

const grid = {
  display: "grid",
  gridTemplateColumns: "48% 48% ",
  gridColumnGap: "5%",
  // gridRowGap: '10px'
};

const AddGrouping = (props) => {

  const { note_grp, fs_grp, notes_no } = props.newSg;
  const parsedNoteGrp = (typeof note_grp === "string" && note_grp.startsWith("{") && note_grp.endsWith("}")) ? JSON.parse(note_grp) : note_grp;


  // const dispatch = useDispatch();
  const init = {
    ledger_name: "",
    sub_grp: "",
  };
  const [field, setField] = useState(init);
  const [disableBtn, setDisableBtn] = useState(true);

  const R_tb_id = useSelector((initialState) => initialState.reducer.tb_id);
  const LOCAL_tb_id = localStorage.getItem("tb_id");
  let tb_id = R_tb_id ? R_tb_id : LOCAL_tb_id;
  const project_id = localStorage.getItem("project_id");

  function handleClose() {
      props.setAddGrouping(false);
  }

  function handleChange(inp, e) {
    setField({ ...field, [inp]: e.target.value });
  }

  useEffect(() => {
    if (field.sub_grp.length > 1) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [field]);

  function handleSubmit() {
    if (field.sub_grp.length < 1) {
      return swal("", "please enter a valid line item name", "warning");
    }
    const auth = localStorage.getItem("auth_token");
    let headers = {
      "x-auth-token": auth,
    };
    setDisableBtn(true);
    const parsedNoteGrp = (typeof note_grp === "string" && note_grp.startsWith("{") && note_grp.endsWith("}")) ? JSON.parse(note_grp) : note_grp;
    const fd = new FormData();
    fd.append("notes_grp", parsedNoteGrp?.notes_grp || note_grp);
    fd.append("sg", field.sub_grp);
    fd.append("fs_grp", props.newSg.fs_grp);
    fd.append("notes_no", notes_no || parsedNoteGrp?.notes_no);
    axios
      .post(`/api/v1/grouping/sg/${project_id}`, fd, { headers })
      .then(() => {
        swal("New Line Item Added Successfully!", {
          icon: "success",
        });
        socket.emit("request-mapped-grouping", { project_id, tb_id });
        setDisableBtn(false);
        props.setAddGrouping(false);
        // props.SetMultiOptions(field);
      })
      .catch((err) => {
        setDisableBtn(false);
        swal(`${err?.response?.data?.error || err.message}`, {
          icon: 'error'
        })
      });
  }

  return (

    <Modal
      title="Create Line Item"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={handleClose}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={handleClose}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label={"Create Line Item"}
            isEnabled={!disableBtn}
            onClick={() => {
              handleSubmit();
            }}
          />
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <span className={`${commoncss.guidingLabel} mb-2`}>{`Add new Line Item to ${parsedNoteGrp?.notes_grp || note_grp}/${notes_no || parsedNoteGrp?.notes_no} of ${fs_grp}`}</span>
        <InputGroup
          class_="mt-2"
          label={`Line Item Name`}
          inputs={[
            <>
              <input
                value={field.sub_grp}
                type="text"
                placeholder="Enter line item"
                onChange={(e) => {
                  handleChange("sub_grp", e);
                }}
              />
            </>,
          ]}
        />
      </div>
    </Modal>
  );
};

export default AddGrouping;
